import { render, staticRenderFns } from "./noticeManageModal.vue?vue&type=template&id=2064c582&scoped=true&"
import script from "./noticeManageModal.vue?vue&type=script&lang=js&"
export * from "./noticeManageModal.vue?vue&type=script&lang=js&"
import style0 from "./noticeManageModal.vue?vue&type=style&index=0&id=2064c582&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064c582",
  null
  
)

export default component.exports